import {
  HeroStatsResponse,
  ListingDetailResponse,
  ListingSummaryResponse,
  SearchSuggestionResponse
} from './listing.response';
import { HeroStatsState, ListingDetailState, ListingSummaryState, SearchSuggestion } from './listing.state';

/** Pure wire → state mappers for the catalog endpoints. */

export function mapListingSummaryResponse(response: ListingSummaryResponse): ListingSummaryState {
  return {
    ...response,
    startsAt: response.startsAt ? new Date(response.startsAt) : null,
    endsAt: response.endsAt ? new Date(response.endsAt) : null,
    listedAt: new Date(response.listedAt)
  };
}

export function mapListingDetailResponse(response: ListingDetailResponse): ListingDetailState {
  return {
    ...response,
    startsAt: response.startsAt ? new Date(response.startsAt) : null,
    endsAt: response.endsAt ? new Date(response.endsAt) : null,
    listedAt: new Date(response.listedAt),
    photoUrls: [...response.photoUrls],
    specs: { ...response.specs },
    fulfilment: { ...response.fulfilment },
    shipping: { ...response.shipping },
    categoryPath: [...response.categoryPath]
  };
}

export function mapSearchSuggestionResponse(response: SearchSuggestionResponse): SearchSuggestion {
  return { ...response };
}

export function mapHeroStatsResponse(response: HeroStatsResponse): HeroStatsState {
  return { ...response };
}
